import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from "@progress/kendo-angular-buttons";
import { TextBoxComponent } from "@progress/kendo-angular-inputs";
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-numeric-up-down',
  standalone: true,
  imports: [
    ButtonComponent,
    TextBoxComponent,
    FormsModule
  ],
  templateUrl: './numeric-up-down.component.html',
  styleUrl: './numeric-up-down.component.scss'
})
export class NumericUpDownComponent {
  @Input({required: true}) value = 0;
  @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();

  public allowOnlyNumbers(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    this.value = parseInt(input.value, 10) || 0;
    this.valueChange.emit(this.value);
  }

  public increment() {
    this.value++;
    this.valueChange.emit(this.value);
  }

  public decrement() {
    if (this.value > 0) {
      this.value--;
      this.valueChange.emit(this.value);
    }
  }

}
